module.exports = __webpack_public_path__ + "img/boost.e7affa5f.png";